import React from 'react';
import { AiRolePlaySubmission } from 'redux/schemas/models/ai-role-play';
import useAiRolePlayHelper from 'lecture_pages/components/ai-role-play/hooks/use-ai-role-play-helper';
import ProfilePicture from 'org_level_profile/components/profile-picture';
import { doubleSpacing } from 'styles/global_defaults/scaffolding';
import RolePlayTitle from 'lecture_pages/components/ai-role-play/ai-conversation-modal/role-play-title';
import { css } from '@emotion/react';
import TopGradientBorder from 'lecture_pages/components/left-panel/novo-ai/components/shared/top-gradient-border';
import UserSubmissionDropdown from './user-submission-dropdown';

type Props = {
  submission?: AiRolePlaySubmission | null;
  rolePlayTitle: string;
  showUser?: boolean;
  rolePlayId?: number;
  catalogId?: string;
};

const SubmissionFeedbackHeader = (props: Props) => {
  const {
    submission,
    rolePlayTitle,
    showUser = true,
    rolePlayId,
    catalogId,
  } = props;
  const { isMobile } = useAiRolePlayHelper();

  return (
    <div>
      <TopGradientBorder />
      <div
        className={`border-bottom d-flex align-items-center pb-1 ${isMobile ? 'px-4' : 'px-6'}`}
        css={css`
          box-shadow: 1px 2px 2px 0px #0000001A;
        `}
      >
        {(showUser && submission?.user) ? (
          <div className='d-flex pt-3 pb-4'>
            <ProfilePicture
              profile={submission.user}
              isRound
              size={doubleSpacing}
            />
            <div className='d-flex my-auto flex-column ml-1'>
              <p className='mb-0 bold text-regular text-gray-1'>
                {submission?.user?.fullName}
              </p>
              <p className='mb-0 text-small text-gray-1'>{rolePlayTitle}</p>
            </div>
          </div>
        ) : (
          <RolePlayTitle title={rolePlayTitle} />
        )}
        {submission && rolePlayId != null && catalogId != null && (
          <div className='ml-auto my-auto flex-shrink-0'>
            <UserSubmissionDropdown
              submission={submission}
              rolePlayId={rolePlayId}
              catalogId={catalogId}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SubmissionFeedbackHeader;
